
import { useEffect } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { cn } from "@/lib/utils";
import { usePayment, useGlobalConfig } from "@/stores/appStore";
import { PaymentType } from "@/stores/slices/commonSlice";

export interface PaymentTabsProps extends React.PropsWithChildren {
  className?: string;
}
export const PaymentTabs = ({
  children,
  className = '',
}: PaymentTabsProps) => {
  const {
    paymentType,
    setPaymentType,
  } = usePayment();

  const { globalConfig } = useGlobalConfig();

  // 调用 fetch 获取配置，fetch 内部已有保护逻辑（已存在或正在加载会直接返回）
  useEffect(() => {
    globalConfig?.fetch?.();
  }, [globalConfig]);

  // 从远程配置获取 paymentTabs，默认为空数组
  const paymentTabs = globalConfig?.value?.paymentTabs || [];

  return (
    <Tabs
      className="relative flex flex-col flex-1 h-full"
      value={paymentType}
      onValueChange={(tab) => {
        setPaymentType(tab as PaymentType)
      }}>
      {
        paymentTabs.length > 1 && <TabsList className={cn(
          "flex fle-row rounded-[10px] h-[54px] w-fit bg-[#DCE4F2] items-center justify-center self-center px-2.5",
          className,
        )}>
          {
            paymentTabs.map(({ value, label }: { value: PaymentType; label: string }) => (
              <TabsTrigger
                key={value}
                className={cn(
                  "data-[state=active]:text-primary data-[state=active]:shadow-none data-[state=active]:rounded-md text-muted-foreground",
                  value === 'upgrade' && paymentType === value && "data-[state=active]:bg-gradient-to-br data-[state=active]:from-[#a08669] data-[state=active]:to-[#553a20] data-[state=active]:text-[#EDDBC0]",
                  value === 'recharge' && paymentType === value && "data-[state=active]:text-primary-foreground data-[state=active]:bg-primary",
                  "h-10 w-[195px] text-lg font-normal",
                  "focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
                )}
                value={value}
              >
                {label}
              </TabsTrigger>
            ))
          }
        </TabsList>
      }
      {children}
    </Tabs>
  )
}